// extracted by mini-css-extract-plugin
export default {"Layout-ocean-primary":"theme-ocean_Layout-ocean-primary__Q3o2+","Layout-ocean-secondary":"theme-ocean_Layout-ocean-secondary__9qayr","Main-ocean":"theme-ocean_Main-ocean__pvxGa"};